<template>
  <nav class="nav-links">

    <!-- API Access -->
    <v-btn flat small v-if="isLoggedIn"
           onclick="window.location='/#api-clients'">
      <a>API Access</a>
    </v-btn>

    <!-- Vuepress docs-->
    <v-btn flat small v-if="isLoggedIn"
           onclick="window.location='/docs/getting-started.html'">
      <a>Docs</a>
    </v-btn>

    <!-- login/register -->
    <v-btn flat small v-if="!isLoggedIn"
           @click="initLogin">
      <a>Log In / Register</a>
    </v-btn>

    <!-- logout -->
    <v-btn flat small v-if="isLoggedIn"
           @click="initLogout">
      <a>Log Out</a>
    </v-btn>

  </nav>
</template>

<script>
export default {
  props: ["auth", "authenticated"],
  computed: {
    isLoggedIn() {
      return this.authenticated;
    }
  },
  methods: {
    initLogin() {
      this.auth.login();
    },
    initLogout() {
      this.auth.logout();
    }
  }
};
</script>

<style lang="stylus">
  @import './styles/config.styl'
  .nav-links
    display inline-block
    a
      line-height 1.4rem
      color #e53935
      &:hover
        color #e53935 !important
      &.router-link-active
        color $accentColor
    .nav-item
      position relative
      display inline-block
      margin-left 1.5rem
      line-height 2rem
    .repo-link
      margin-left 1.5rem

  @media (max-width: $MQMobile)
    .nav-links
      .nav-item, .repo-link
        margin-left 0

  @media (min-width: $MQMobile)
    .nav-links a
      &:hover, &.router-link-active
        color $textColor

    .nav-item > a:not(.external)
      &:hover, &.router-link-active
        margin-bottom -2px
        border-bottom 2px solid lighten($accentColor, 8%)
</style>
